<div style="background-color: #fff; border-radius: 12px; border: 1px solid #bdbdbd" class="p-2">
  <div style="display: flex; margin-top: 5px; margin-left: 5px">
    <div style="flex-grow: 1; margin-bottom: 16px">
      <div style="font-size: 24px; font-weight: 600; margin-bottom: 8px">Your Progress</div>
      <div style="font-size: 14px; color: #808080; margin-left: 3px">
        For completed grabbed jobs this week
      </div>
    </div>
    <div style="flex-shrink: 1; cursor: pointer" (click)="showBadgeInfo()">
      <img
        src="/assets/images/gamification/question-circle.svg"
        style="vertical-align: middle"
        width="24px"
      />
    </div>
  </div>

  <div class="circle-container" *ngIf="badges && badgeProgress">
    <div class="circle-progress">
      <badge-progress-circle
        [badge]="badgeProgress.latestBadge?.badge"
        [progress]="badgeProgress.latestBadge?.progress"
        [moves]="badgeProgress.grabbedJobsCount"
      >
      </badge-progress-circle>
    </div>

    <div *ngIf="badgeProgress.nextBadge" style="margin-top: 10px">
      <span style="color: #808080"
        >Complete <b>{{ badgeProgress.nextBadge.leftToEarn }}</b> grabbed jobs to earn</span
      >
      <img
        [src]="
          '/assets/images/gamification/badge-' +
          badgeProgress.nextBadge.badge.name.toLowerCase() +
          '.svg'
        "
        [alt]="badgeProgress.nextBadge.badge.name"
        style="vertical-align: middle"
        class="badge-image-small"
      />
      <span>{{ badgeProgress.nextBadge.badge.name }}</span>
    </div>

    <div class="grab-text" (click)="grabMovement()">Grab your next job &#8594;</div>
  </div>

  <!-- Badge definitions -->
  <div style="padding: 0 20px">
    <div class="badge-definition-container">
      <div
        *ngFor="let data of progressData; let i = index"
        [class.flex-grow-1]="i < progressData.length - 1"
        [class.flex-shrink-1]="i == progressData.length - 1"
      >
        <div style="display: flex; width: 100%">
          <div style="width: 60px">
            <badge-progress-small-circle [badge]="data.badge" [progress]="data.progress">
            </badge-progress-small-circle>
          </div>
          <div
            *ngIf="i < progressData.length - 1"
            style="margin-top: 56px; flex-grow: 1; box-shadow: inset 0 6px 0 #e4e4e4"
          >
            <div [style.width]="getBadgeLineProgress(data, i)" class="progress-width"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  *ngIf="badges"
  header="How the badges work"
  [visible]="badgeDialogVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '450px' }"
  (visibleChange)="dialogVisibleChanged($event)"
>
  <div class="grey-text">
    Grab and complete {{ badges[badges.length - 1].earnValue }} jobs by the end of the week to win a
    Platinum badge and benefits
  </div>
  <div class="list-container">
    <div class="list-row">
      <div class="list-left list-header"># of Jobs</div>
      <div class="list-center list-header" style="padding-left: 0">Level Reached</div>
      <div class="list-right list-header">Benefit</div>
    </div>
    <div *ngFor="let badge of badges; let i = index" class="list-row">
      <div class="list-left">{{ badge.earnValue }} Jobs</div>
      <div class="list-center">
        <img
          [src]="'/assets/images/gamification/badge-' + badge.name.toLowerCase() + '.svg'"
          [alt]="badge.name"
          style="vertical-align: middle"
          class="badge-image"
        />&nbsp;{{ badge.name }}
      </div>
      <div class="list-right">
        <b>{{ (badge.reward | currency : 'GBP' : 'symbol' : '1.2-2') || 'TBC' }}</b>
      </div>
    </div>
  </div>
  <div class="grab-button">
    <button
      style="width: 100%"
      type="button"
      class="blue-btn"
      pButton
      (click)="grabMovement()"
      label="Grab Job &#8594;"
    ></button>
  </div>
</p-dialog>
